import React from 'react';

import { Link } from 'gatsby';
import wwwApconCom from '../../../www.apcon.com';
import ButtonIcon from '../../utils/ButtonIcon';
import { SolutionsContent } from './_Context';
import technologies from '../../../content/technologies';
import industries from '../../../content/industries';
import Icon from '@components/utils/IconWrap';

const PageLink = props => {
  const { pageLink } = props;

  return (
    <li className="py-1">
      <Link
        to={pageLink.url}
        className="inline-flex text-sm text-primary ease-in-out pl-1 transition duration-500 hover:transition hover:duration-500 hover:text-info hover:underline"
      >
        <ButtonIcon icon={pageLink.icon} className="" position="leading" />
        <span className="text-base-content hover:text-info-700">
          {' '}
          {pageLink.name}
        </span>
      </Link>
    </li>
  );
};

export default function SolutionsDock() {
  const { LearnMore } = SolutionsContent;

  return (
    <div className="container mx-auto px-0 lg:px-8">
      <div className="py-5 flex flex-row gap-5 justify-around">
        <div className="flex flex-col gap-8 basis-1/4 border-r-2 border-base-200 pr-4">
          <a
            href={wwwApconCom.channelPartners}
            className=" hover:bg-base-300 hover:border-base-200 shadow-base-content/30 hover:shadow-lg transition-all duration-300 rounded-lg  p-4"
          >
            <div className="font-extrabold underline text-primary">
              Channel Partners
            </div>
            <div className="text-sm text-neutral">
              APCON stands shoulder - to - shoulder with a broad cross - section
              of high - tech providers to deliver our solutions quickly and
              efficiently.Check out our partner list or inquire about becoming
              one.
            </div>
          </a>
        </div>

        {/* for datacenters */}
        <div className="basis-1/4">
          <div className="text-primary pb-3 font-extrabold"> OUR FEATURES</div>
          <div className="h-full flex flex-row">
            <ul className="flex h-full flex-col overflow-hidden flex-wrap gap-2 text-left">
              {technologies.map(technology => (
                <Link
                  key={technology.id}
                  to={technology.url}
                  className="inline-flex text-sm text-primary ease-in-out pl-1 transition duration-500 hover:transition hover:duration-500 hover:text-info hover:underline items-center"
                >
                  <Icon icon={technology.icon} size="4" />
                  <span className="text-base-content hover:text-info-700 ml-2">
                    {technology.title}
                  </span>
                </Link>
              ))}
            </ul>
          </div>
        </div>

        {/* For Industries */}
        <div className="basis-1/4">
          <div className="text-primary pb-3 font-extrabold"> INDUSTRIES </div>
          <div className="h-full flex flex-row">
            <ul className="flex h-full flex-col overflow-hidden flex-wrap gap-2 text-left">
              {industries.map(industry => (
                <Link
                  key={industry.id}
                  to={industry.url}
                  className="inline-flex text-sm text-primary ease-in-out pl-1 transition duration-500 hover:transition hover:duration-500 hover:text-info hover:underline"
                >
                  <Icon icon={industry.icon} className="w-4 h-4 mr-2" />
                  <span className="text-base-content hover:text-info-700">
                    {industry.title}
                  </span>
                </Link>
              ))}
            </ul>
          </div>
        </div>

        {/* learn more */}
        <div className="basis-1/4">
          <div className="text-primary pb-3 font-extrabold"> WHAT WE DO</div>
          <div className="h-full flex flex-row">
            <ul className="flex h-full flex-col text-neutral overflow-hidden flex-wrap text-left">
              {LearnMore.map(dcl => (
                <PageLink Key={dcl.key} pageLink={dcl} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
